angular.module('graph').controller('ph-webinars', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast', 'fxScrollFactory', 'goto-search',
    function(
        $scope, $root, $core, $broadcast, $scroll, $search
    ) {
        $scope.search = ''; $search.watch($scope, 'webinar', 'search');


        /**
         *
         */
        $scope.webinars = [];

        $scope.$page    = 0;

        $scope.$pagc    = -1;

        $scope.$let     = 0;

        $scope.loader   = 1;

        $scope.$filter  = 'all';

        $scope.space    = 'me';

        $scope.$entry  = function($space, $filter) {
            if ($space) $scope.space = $space;

            if ($filter) $scope.$filter = $filter;
        };

        $scope.init  = function($space, $filter) {
            if ($space) $scope.space = $space;

            if ($filter) $scope.$filter = $filter;

            $scope.find();
        };

        /**
         *
         */
        $scope.find = function(next) {
            // console.log(next);
            // if ($scope.$pagc > -1 && $scope.$pagc === $scope.$page)
            //     return;

            $scope.loader   = 1;

            var $query = $core.$uri.$query.new({
                page    : +(++$scope.$page),
                let     : $scope.$let,
                filter  : $scope.$filter,
            }).str();

            $core.get('/xhr/' + $scope.space + '/webinars?' + $query)
                .then(function($response) {
                    if ($response.data.state === 0 && $response.data.data.length > 0) {
                        // $scope.$pagc = $response.data.pages;

                        var connect = [];

                        /**
                         *
                         */
                        for (var i = 0; i < $response.data.data.length; i++) {
                            connect.push($response.data.data[i].id);
                        }

                        /**
                         *
                         */
                        $broadcast.emit('join:webinar', connect);

                        /**
                         *
                         */
                        $scope.webinars = $scope.webinars.concat(
                            $response.data.data
                        );


                        if (next) next();
                    }

                    $scope.loader = 0;
                });
        };

        $scope.filter = function($name) {
            $scope.$filter  = $name;

            $scope.webinars = [];

            $scope.$page    = 0;

            $scope.$let     = 0;

            $scroll.renew('webinars');

            $scope.find();
        };

        /**
         *
         */
        $broadcast.on('webinar:update', function($data, $guid) {
            if ($core.$guid !== $guid)
                $core.$array.find($scope.webinars, $data['entry'].id, function(webinar) {
                    $core.$object.replace(webinar, $data['entry']);
                });
        });

        /**
         *
         */
        $broadcast.on('webinar:participant:join', function($data, $guid) {
            if ($core.$guid !== $guid)
                $core.$array.find($scope.webinars, $data['entry'].id, function(webinar) {
                    ++webinar.participants;
                });
        });

        /**
         *
         */
        $broadcast.on('webinar:participant:leave', function($data, $guid) {
            if ($core.$guid !== $guid)
                $core.$array.find($scope.webinars, $data['entry'].id, function(webinar) {
                    --webinar.participants;
                });
        });
    }
]);

angular.module('graph').controller('ph-webinar-create', [
        '$scope', '$rootScope', 'ph-core', 'ph-broadcast', 'ph-date-service', '$timeout',
    function(
        $scope, $root, $core, $broadcast, $date, $timeout
    ) {
        $scope.dpconf    = {
            dateFormat: "ll",
            minDate: new Date().toDateString()
        };

        $scope.submitted = false;
        $scope.webinar    = {};

        var start = moment().add(1, 'hour');
        var end   = moment().add(2, 'hour');

        $scope.dates    = {
            "start"     : {
                "date"  : start.format("ll"),
                "time"  : start.format("HH:mm")
            },
            "end"     : {
                "date"  : end.format("ll"),
                "time"  : end.format("HH:mm")
            }
        };

        $scope.show_diff = function() {
            var start = moment($scope.dates.start.date, "ll").set({
                "hour": moment($scope.dates.start.time, "HHmm").get('hour'),
                "minute": moment($scope.dates.start.time, "HHmm").get('minute')
            });

            var end = moment($scope.dates.end.date, "ll").set({
                "hour": moment($scope.dates.end.time, "HHmm").get('hour'),
                "minute": moment($scope.dates.end.time, "HHmm").get('minute')
            });

            $scope.dates.diff = end.diff(start) / 1000;
        };

        $scope.create    = function() {

            var st1_time = moment($scope.dates.start.time, "HHmm");
            var st1_date = moment($scope.dates.start.date, "ll");

            $scope.webinar.started_at = st1_date.set({
                "hour": st1_time.get('hour'),
                "minute": st1_time.get('minute')
            }).format();

            var st2_time = moment($scope.dates.end.time, "HHmm");
            var st2_date = moment($scope.dates.end.date, "ll");

            $scope.webinar.ended_at = st2_date.set({
                "hour": st2_time.get('hour'),
                "minute": st2_time.get('minute')
            }).format();

            var diff = moment($scope.webinar.started_at).isBefore($scope.webinar.ended_at);
            var diff_current = moment($scope.webinar.started_at).isAfter(moment().format());

            $scope.form.error = {};

            if (diff === true && diff_current === true && $scope.submitted === false) {
                $root.screen_lock = 1;
                $scope.submitted = true;

                $timeout(function() {
                    $core.post('/xhr/webinars', $scope.webinar).then(function($response) {


                        if ($response.data.state === 0) {
                            window.location.href = '/webinar/' + $response.data.data.id;
                        } else {
                            $root.screen_lock = 0;
                            $scope.submitted = false;
                            $scope.form.error = $response.data.data;
                        }
                    });
                });
            } else {
                if (diff === false)
                    $scope.form.error.diff_date = 1;

                if (diff_current === false)
                    $scope.form.error.diff_current = 1;
            }
        }
    }
]);

angular.module('graph').controller('ph-webinar-read', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast', '$timeout',
    function(
        $scope, $root, $core, $broadcast, $timeout
    ) {
        $scope.picture = {};
        $scope.webinar = {};
        $scope.$let    = 0;

        $scope.$event = {
            "update" : function($data) {
                ++$scope.webinar.participants;
                $scope.webinar.is.participant = true;
            },
            "upload" : function($data) {
                ++$scope.webinar.participants;
                $scope.webinar.is.participant = true;
            },
            "join"  : function($integration) {
                ++$scope.$let;
                ++$scope.webinar.participants;

                if ($integration === true) {
                    // $scope.webinar.is.participant = true;
                    location.reload();
                }
            },
            "leave" : function($integration) {
                --$scope.$let;
                --$scope.webinar.participants;

                if ($integration === true) {
                    // $scope.webinar.is.participant = false;
                    location.reload();
                }
            }
        };

        $scope.$request = {
            "join" : function() {
                $core.$with.lock(function($unlock) {
                    $timeout(function() {
                        $core.post('/xhr/webinar/' + $scope.webinar.id + '/participants').then(function($response) {
                            $scope.$event.join(true);

                            // $unlock();
                        });
                    }, 1000);
                });
            },
            "leave" : function() {
                $core.$with.lock(function($un) {
                    $timeout(function() {
                        $core.delete('/xhr/webinar/' + $scope.webinar.id + '/participants').then(function($response) {
                            $scope.$event.leave(true);

                            // $un();
                        });
                    }, 1000);
                });
            }
        };

        $scope.upload   = function() {
            if ($scope.form.upload.$valid === true) {
                $core.post('/xhr/webinar/' + $scope.webinar.id + '/picture', {
                    name    : $scope.picture.name,
                    photo   : $scope.picture.base
                }).then(function($response) {
                    if ($response.data.state === 0) {
                        $scope.webinar.picture = $response.data.data;
                    } else {
                        $root.$broadcast('ph-modal-show', $response.data.data.photo);
                    }
                });
            }
        };

        $scope.listen = function($id) {
            $broadcast.emit('join:webinar', [
                $scope.webinar.id
            ]);
        };

        /**
         *
         */
        $broadcast.on('webinar:update', function($data, $guid) {
            if ($core.$guid !== $guid)
                    $core.$object.replace($scope.webinar, $data['entry']);
        });

        /**
         *
         */
        $broadcast.on('webinar:participant:join', function($data, $guid) {
            if ($core.$guid !== $guid)
                $scope.$event.join(
                    +($data.user.id) === +($root.user.id)
                );
        });

        /**
         *
         */
        $broadcast.on('webinar:participant:leave', function($data, $guid) {
            if ($core.$guid !== $guid)
                $scope.$event.leave(
                    +($data.user.id) === +($root.user.id)
                );
        });
    }
]);

angular.module('graph').controller('ph-read-webinars-tab', [
    '$scope', 'ph-touch-service', '$controller',
    function(
        $scope, $phtouch, $controller
    ) {
        angular.extend(this, $controller('ph-webinars', {$scope: $scope}));
        var $module     = 'ph-read-webinars-tab';

        $phtouch.$watch($scope, $module, function() {
            $phtouch.$touch($module, function() {
                $scope.find();
            });
        });
    }
]);

angular.module('graph').controller('ph-webinar-read-participant-tab', [
    '$scope', 'ph-touch-service', 'ph-core', 'ph-broadcast',
    function(
        $scope, $phtouch, $core, $broadcast
    ) {
        $scope.participants = [];
        $scope.$page    = 0;
        $scope.$let     = 0;

        var $module     = 'ph-webinar-read-participant-tab';

        $phtouch.$watch($scope, $module, function() {
            $phtouch.$touch($module, function() {
                $scope.find();
            });
        });

        $scope.find = function() {
            var $query = $core.$uri.$query.new({
                page    : +(++$scope.$page),
                let     : $scope.$let,
            }).str();

            $core.get('/xhr/webinar/' + $scope.$parent.webinar.id + '/participants?' + $query)
                .then(function($response) {
                    $scope.participants = $scope.participants.concat(
                        $response.data.data
                    );
                });
        };

        /**
         *
         */
        $broadcast.on('webinar:participant:join', function($data, $guid) {
            if ($core.$guid !== $guid && $phtouch.$is($module)) {
                ++$scope.$let;
                $scope.participants.unshift($data.user);
            }
        });

        /**
         *
         */
        $broadcast.on('webinar:participant:leave', function($data, $guid) {
            if ($core.$guid !== $guid && $phtouch.$is($module))
                $core.$array.rm($scope.participants, $data.user.id, function() {
                    --$scope.$let;
                });
        });
    }
]);

angular.module('graph').controller('ph-webinar-settings', [
        '$scope', '$rootScope', 'ph-core', 'ph-broadcast', 'ph-date-service', '$timeout',
    function(
        $scope, $root, $core, $broadcast, $date, $timeout
    ) {
        $scope.dpconf    = {
            dateFormat: "ll"
        };

         $scope.webinar   = {};
         $scope.submitted = false;

         $scope.dates    = {
             "start"     : {
                 "date"  : '2016-11-28',
                 "time"  : '14:00',
             },
             "end"     : {
                 "date"  : '2016-11-28',
                 "time"  : '14:00',
             }
         };

         $scope.parse     = function($webinar) {
             $scope.webinar = $webinar;

             var $start = moment(
                 $webinar.started_at
             );

             var $end  = moment(
                 $webinar.ended_at
             );

            $scope.dates    = {
                "start"     : {
                    "date"  : $start.format('ll'),
                    "time"  : $start.format("HH:mm")
                },
                "end"     : {
                    "date"  : $end.format('ll'),
                    "time"  : $end.format("HH:mm")
                }
            };
         };

        $scope.show_diff = function() {
            var start = moment($scope.dates.start.date, "ll").set({
                "hour": moment($scope.dates.start.time, "HHmm").get('hour'),
                "minute": moment($scope.dates.start.time, "HHmm").get('minute')
            });

            var end = moment($scope.dates.end.date, "ll").set({
                "hour": moment($scope.dates.end.time, "HHmm").get('hour'),
                "minute": moment($scope.dates.end.time, "HHmm").get('minute')
            });

            $scope.dates.diff = end.diff(start) / 1000;
            $scope.dates.start_diff_current = moment(start.format()).isAfter(moment().format());
        };

        $scope.update = function () {
            var st1_time = moment($scope.dates.start.time, "HHmm");
            var st1_date = moment($scope.dates.start.date, "ll");

            $scope.webinar.started_at = st1_date.set({
                "hour": st1_time.get('hour'),
                "minute": st1_time.get('minute')
            }).format();

            var st2_time = moment($scope.dates.end.time, "HHmm");
            var st2_date = moment($scope.dates.end.date, "ll");

            $scope.webinar.ended_at = st2_date.set({
                "hour": st2_time.get('hour'),
                "minute": st2_time.get('minute')
            }).format();

            var diff = moment($scope.webinar.started_at).isBefore($scope.webinar.ended_at);

            $scope.form.error = {};

            if (diff === true && $scope.submitted === false) {
                $root.screen_lock = 1;
                $scope.submitted = true;

                $timeout(function () {
                    $core.post('/xhr/webinar/' + $scope.webinar.id, $scope.webinar).then(function ($response) {
                        $root.screen_lock = 0;

                        if ($response.data.state === 0) {
                            window.location.href = '/webinar/' + $scope.webinar.id;
                        } else {
                            $root.screen_lock = 0;
                            $scope.submitted = false;
                            $scope.form.error = $response.data.data
                        }
                    });
                });
            } else {
                $scope.form.error.diff_date = 1;
            }
        }
}]);
